import { Element } from '@craftjs/core';

import { ListItemsSection } from '../ListItemsSection/ListItemsSection';

export interface EditableRegionProps {
  /**
   * The ID of the region to edit (e.g. 'body', 'footer')
   * This corresponds to a block ID in the CommonData.
   */
  regionId: string;
}

export function EditableRegion({ regionId }: EditableRegionProps) {
  return <Element id={regionId} is={ListItemsSection} />;
}
